//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserInfoToast from "@/components/toast/userInfo";
import mixinTxrNewWeb from "@/utils/mixin/mixinTxrNewWeb";
import mixinVerify from "@/utils/mixin/mixinVerify";
import { getFormatInfo, getDeScheme } from "./index";

import { store, mutations } from "@/observable/store";
import { uninsuredInfo } from "@/model/javaApi/present.js";
import { toApp } from "@/utils/appBridge";

import InstructionProtocol from "@/views/stencil/components/instructionProtocol";
import NewProtocol from "@/views/stencil/components/newProtocol";
import Model from "./components/model";
import InTitle from "@/views/stencil/components/title";
import Editor from "@/views/stencil/components/editor";
import Tab from "./components/tab.vue";
import SchemeTab from "./components/SchemeTab.vue";
import Giveup from "./components/Giveup";
import FixBottom from "./components/fixBottom";

export default {
  name: "attachPresent",
  mixins: [mixinTxrNewWeb, mixinVerify],
  data() {
    return {
      allData: {}, // 展示内容
      modeShow: false, //是否展示保险详情
      current: 0, //详情选中
      fromData: {}, // 用户信息
      currentScheme: {}, //方案信息
      key: 0,
      protocolInfo: {}, //授权弹窗信息
    };
  },
  components: {
    InstructionProtocol,
    NewProtocol,
    Model,
    InTitle,
    Editor,
    Tab,
    UserInfoToast,
    SchemeTab,
    Giveup,
    FixBottom,
  },
  computed: {
    // 渠道商品code
    channelCommodityCode() {
      return this.$route.query.channelCommodityCode;
    },
    // 主站订单号
    baseNo() {
      return this.$route.query.baseNo || "";
    },
    // 传入的方案code
    scheme_code() {
      return this.$route.query.scheme_code || "";
    },
    // uid
    uid() {
      return store.uid;
    },
  },
  created() {
    this.getInfo();
    mutations.setAttachPresentInsur_name(this.$route.query.insur_name || "");
  },
  beforeRouteLeave: (to, from, next) => {
    // 除去条款页 保留参数
    if (to.path != "/iframePage") {
      mutations.setAttachPresentInsur_name("");
    }
    next();
  },
  mounted() {
    // 登录
    if (this.uid == 0) {
      this.$refs.userlogin.showoast();
    }
    this.$nextTick(() => {
      // 回溯视频
      this.postTX(this.channelCommodityCode);
    });
  },
  methods: {
    changeData({ allFromData, fromPageData }) {
      this.fromData = fromPageData;
      console.log("changeData", fromPageData);
    },
    changeScheme(item) {
      this.currentScheme = item;
      console.log("changeScheme", item);
      this.STATISTICS_CONFIG.insur_insurinfoinput_scheme_change_click({
        ex: { scheme: item.schemeName },
      });
    },

    // 获取数据
    async getInfo() {
      let schemeName = "";

      this.allData = await getFormatInfo({
        channelCommodityCode: this.channelCommodityCode,
      });
      console.log('allData: ', this.allData)
      this.currentScheme = getDeScheme(this.allData.schemes, this.scheme_code);
      this.key = this.key + 1;
      this.AppSetTitleBar(this.allData.topTitle, ["refresh"]);
      this.STATISTICS_CONFIG.insur_insurinfoinput_page({
        ex: { scheme: this.currentScheme.schemeName },
      });
    },
    submitClick() {
      this.$refs.InstructionProtocol.selectFlag = true;
      this.btnClick();
    },
    //立即投保
    btnClick() {
      if (this.uid == 0) {
        this.$refs.userlogin.showoast();
        return false;
      }

      let schemeCurrent = this.currentScheme;
      const data = {
        elements: this.fromData,
        channelCommodityCode: this.channelCommodityCode,
        isFollow: this.allData.isFollow,
        originalPrice: schemeCurrent.originalPrice, // 划线价
        commodityPrice: schemeCurrent.commodityPrice,
        price: schemeCurrent.commodityPrice,
        baseNo: this.$route.query.baseNo || "", // 主站订单号
        traceId: store.TXoption.bizKey, // 回溯信息
        schemeCode: schemeCurrent.schemeCode, //方案code  目前只有一种
        ch: this.$route.query.ch || "",
      };
      this.protocolInfo = {
        productName: this.allData.commodityName,
        buyerName: this.fromData["BUYER_NAME"].value,
        insuredName: this.fromData["BUYER_NAME"].value,
      };
      // 统一核保
      this.verification(data)
        .then((res) => {
          this.goConfirm();
          this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({
            ex: { status: "pass" },
          });
        })
        .catch((res) => {
          this.STATISTICS_CONFIG.insur_insurinfoinput_submit_click({
            ex: { status: "fail" },
          });
        });
    },
    // 去创建订单
    goConfirm() {
      let reviewType = this.$route.query.origin || "presentOrder"; //下单类型用于区分下单完成的后续流程
      if (reviewType == "presentOrder") {
        // 赠险确认订单页 不需要下单
        this.mixinToAppPresentInsurance();
      } else {
        this.mixinCreatAnOrder();
      }
    },
    // 展示服务详情
    showDetail() {
      this.modeShow = true;
      // 重置 current
      this.allData.schemeServiceList.map((item, index) => {
        if (item.schemeCode == this.currentScheme.schemeCode) {
          this.current = index;
        }
      });

      this.STATISTICS_CONFIG.insur_insurinfoinput_insurdetail_click();
    },
  },
};
